module.exports = __webpack_public_path__ + "img/62.74be4c30.jpg";